import axios from "axios"
import router from '../router/index.js'
import {Spin}  from 'view-design';
import Qs from "qs"

const ajax = axios.create({
	baseURL: 'http://127.0.0.1:8002/serena/'
})

/**
 * 添加请求拦截器
 * @param {Object} config
 */
ajax.interceptors.request.use(function(config) {
	config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
	// 在发送请求之前做些什么
	return config;
}, function(error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

/**
 * 添加响应拦截器
 * @param {Object} response
 */
ajax.interceptors.response.use(function(response) {
	// 对响应数据做点什么
	return response;
}, function(error) {
	// 对响应错误做点什么
	return Promise.reject(error);
});

export function sendMsg(url, parms, methods, isJSON) {
	return new Promise((reslove, reject) => {
		let token = localStorage.getItem('Authorization');
		Spin.show();
		axios({
			method: methods,
			// url: url.indexOf("http") >= 0 ? url : 'http://127.0.0.1:8001/serena/official' + url,
			url: url.indexOf("http") >= 0 ? url : 'https://www.hjyxbx.com/news/' + url,
			
			data: parms,
			headers: {
				token: token
			},
			transformRequest: [function(data) {
				let ret = ''
				ret = Qs.stringify(data);
				return ret
			}]
		}).then(res => {
			Spin.hide();
			reslove(res)
		})
	})
}

export default ajax;
